/**
 * Helpers for WhatsApp send API responses (Meta Cloud API).
 */

/** @param {string} [e164] digits only, e.g. 919288507778 */
export function formatWhatsAppE164(e164) {
  const digits = String(e164 || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('91') && digits.length === 12) {
    const local = digits.slice(2);
    return `+91 ${local.slice(0, 5)} ${local.slice(5)}`;
  }
  if (digits.length > 10) {
    const ccLen = digits.length - 10;
    return `+${digits.slice(0, ccLen)} ${digits.slice(ccLen)}`;
  }
  return `+${digits}`;
}

export function resolveWhatsAppDestination(res) {
  return res?.whatsapp_to_display || formatWhatsAppE164(res?.whatsapp_to) || '';
}

/**
 * @param {object} res API response with whatsapp_sent / whatsapp_to_display
 * @param {{ prefix?: string, bookingCode?: string }} [opts]
 */
export function formatWhatsAppSuccessMessage(res, opts = {}) {
  const to = resolveWhatsAppDestination(res);
  const defaultPrefix = res?.whatsapp_delivery_mode === 'template'
    ? 'WhatsApp message queued'
    : 'Payment link queued on WhatsApp';
  const prefix = opts.prefix || defaultPrefix;
  const booking = opts.bookingCode ? ` (booking ${opts.bookingCode})` : '';
  const destination = to ? ` to ${to}` : '';
  const mode = res?.whatsapp_delivery_mode === 'template' ? ' via approved template' : '';
  return `${prefix}${destination}${booking}${mode}.`.replace(/\s+/g, ' ').trim();
}

export function collectWhatsAppResponseNotes(res) {
  const notes = [...(res?.warnings || [])].filter(Boolean);
  if (res?.whatsapp_sent && res?.whatsapp_message_id) {
    notes.push(`Meta message ID: ${res.whatsapp_message_id}`);
  }
  return notes;
}

export function formatWhatsAppErrorMessage(res, fallback = 'WhatsApp was not delivered.') {
  const to = resolveWhatsAppDestination(res);
  const err =
    res?.whatsapp_user_message
    || res?.errors?.filter(Boolean)?.[0]
    || fallback;
  if (to && !err.includes(to)) {
    return `${err} (attempted: ${to})`;
  }
  return err;
}
